// import React, { useState, useEffect } from "react";
// import axios from "axios";

// interface WithdrawItem {
//   id: string;
//   uid: string;
//   date: string;
//   wallet: string;
//   amount: number;
//   coin: string;
//   name: string;
//   amount_usdt: number;
//   status: string;
// }

// const Withdraw = () => {
//   const [withdrawData, setWithdrawData] = useState<WithdrawItem[]>([]);
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     fetchWithdrawData();
//   }, []);

//   const fetchWithdrawData = async () => {
//     try {
//       const response = await axios.get("https://bkk07.com/getWithdrawData");
//       const data = response.data;

//       if (Array.isArray(data)) {
//         // Sort data by date (newest first)
//         const sortedData = data.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
//         setWithdrawData(sortedData);
//       } else {
//         console.error("Unexpected response structure:", data);
//         setWithdrawData([]);
//       }
//     } catch (error) {
//       console.error("Failed to fetch withdrawal data:", error);
//       setWithdrawData([]);
//     }
//   };

//   const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setSearchTerm(event.target.value);
//   };

//   const handleStatusChange = async (withdrawId: string, newStatus: string) => {
//     try {
//       await axios.post("https://bkk07.com/updateWithdrawStatus", {
//         id: withdrawId,
//         status: newStatus,
//       });

//       setWithdrawData((prevData) =>
//         prevData.map((withdraw) =>
//           withdraw.id === withdrawId ? { ...withdraw, status: newStatus } : withdraw
//         )
//       );
//     } catch (error) {
//       console.error("Failed to update status:", error);
//     }
//   };

//   const filteredWithdrawData = searchTerm
//     ? withdrawData.filter(
//         (withdraw) =>
//           String(withdraw.uid).includes(searchTerm) ||
//           withdraw.name.toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     : withdrawData;

//   return (
//     <div className="ml-0 lg:ml-[256px] p-6 bg-gray-900 min-h-screen text-white">
//       {/* Search Bar */}
//       <div className="mb-6">
//         <input
//           type="text"
//           placeholder="Search by name or UID"
//           value={searchTerm}
//           onChange={handleSearchChange}
//           className="p-3 border rounded-lg w-full bg-gray-800 text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500"
//         />
//       </div>

//       {/* List of Withdrawals (Card-Based) */}
//       <div className="space-y-4">
//         {filteredWithdrawData.length > 0 ? (
//           filteredWithdrawData.map((withdraw, index) => (
//             <div
//               key={withdraw.id}
//               className="bg-gray-800 p-5 rounded-xl shadow-lg hover:bg-gray-700 transition duration-300"
//             >
//               <div className="flex justify-between items-center">
//                 <div>
//                   <h2 className="text-lg font-semibold">
//                     {withdraw.name} <span className="text-sm text-gray-400">(UID: {withdraw.uid})</span>
//                   </h2>
//                   <p className="text-sm text-gray-400">{new Date(withdraw.date).toLocaleDateString()}</p>
//                 </div>
//                 <div className="text-right">
//                   <p className="text-lg font-bold text-green-400">{withdraw.amount_usdt.toFixed(2)} USDT</p>
//                   <p className="text-sm text-gray-400">{withdraw.amount} {withdraw.coin}</p>
//                 </div>
//               </div>

//               <div className="mt-4">
//                 <p className="text-gray-300 text-sm truncate">
//                   <span className="font-semibold">Wallet:</span> {withdraw.wallet}
//                 </p>
//               </div>

//               <div className="mt-4 flex justify-between items-center">
//                 <span
//                   className={`px-3 py-1 text-sm font-semibold rounded-full ${
//                     withdraw.status === "In Queue"
//                       ? "bg-yellow-500 text-black"
//                       : withdraw.status === "Processing"
//                       ? "bg-blue-500 text-white"
//                       : withdraw.status === "Done"
//                       ? "bg-green-500 text-white"
//                       : "bg-red-500 text-white"
//                   }`}
//                 >
//                   {withdraw.status}
//                 </span>

//                 <select
//                   value={withdraw.status}
//                   onChange={(e) => handleStatusChange(withdraw.id, e.target.value)}
//                   className="p-2 border rounded-lg bg-gray-700 text-white cursor-pointer hover:bg-gray-600"
//                 >
//                   <option value="In Queue">In Queue</option>
//                   <option value="Processing">Processing</option>
//                   <option value="Done">Done</option>
//                   <option value="Wager Not Completed">Wager Not Completed</option>
//                 </select>
//               </div>
//             </div>
//           ))
//         ) : (
//           <p className="text-center text-gray-400">No withdrawal records found.</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Withdraw;
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Snackbar, Alert, AlertColor } from "@mui/material";
import { BASE } from "../utils/api";

interface WithdrawItem {
  id: string;
  uid: string;
  date: string;
  wallet: string;
  amount: number;
  coin: string;
  name: string;
  amount_usdt: number;
  status: string;
  chain:string;
}

interface FiatWithdrawItem {
  id: string;
  uid: string;
  date: string;
  amount: number;
  currency: string;
  bank_name: string | null;
  account_number: string | null;
  account_holder_name: string;
  ifsc_code: string | null;
  upi_id: string | null;
  status: string;
  name: string;
  txn_id: string | null;
}

// The txn reference is only entered while a payout is actually being actioned.
// Any other status (In Queue, Rejected, ...) shows it read-only.
const TXN_ID_EDITABLE_STATUSES = ["Processing", "Done"];

// A reference can be written exactly once — after that it is a permanent record
// of the payout and stays read-only.
const isTxnIdEditable = (withdraw: Pick<FiatWithdrawItem, "status" | "txn_id">) =>
  TXN_ID_EDITABLE_STATUSES.includes(withdraw.status) && !withdraw.txn_id;

const WithdrawSelf = () => {
  const [withdrawData, setWithdrawData] = useState<WithdrawItem[]>([]);
  const [fiatWithdrawData, setFiatWithdrawData] = useState<FiatWithdrawItem[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const userRole = localStorage.getItem('userRole') || 'User';
  const isSuperAdmin = userRole === 'SuperAdmin';
  const [activeTab, setActiveTab] = useState<"crypto" | "fiat">(isSuperAdmin ? "crypto" : "fiat");
  const [statusFilter, setStatusFilter] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  // Admin-entered payout transaction reference, keyed by withdrawal id
  const [txnInputs, setTxnInputs] = useState<Record<string, string>>({});
  const [savingTxnId, setSavingTxnId] = useState<string | null>(null);
  const [toast, setToast] = useState<{ open: boolean; message: string; severity: AlertColor }>({
    open: false,
    message: "",
    severity: "success",
  });

  const showToast = (message: string, severity: AlertColor = "success") =>
    setToast({ open: true, message, severity });
     const staffId  = localStorage.getItem('currentUserId');

  useEffect(() => {
    fetchWithdrawData();
    fetchFiatWithdrawData();
  }, []);

  const fetchWithdrawData = async () => {
    try {
      const response = await axios.get(`${BASE}/getWithdrawData`, {
  headers: {

    "x-staff-id": staffId ?? ""
  }
    });
      const data = response.data;

      if (Array.isArray(data)) {
        // Sort data by date (newest first)
        const sortedData = data.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        setWithdrawData(sortedData);
      } else {
        console.error("Unexpected response structure:", data);
        setWithdrawData([]);
      }
    } catch (error) {
      console.error("Failed to fetch withdrawal data:", error);
      setWithdrawData([]);
    }
  };

  const fetchFiatWithdrawData = async () => {
    try {
      const response = await axios.get(`${BASE}/getFiatWithdrawData`, {
  headers: {

    "x-staff-id": staffId ?? ""
  }
    });
      const data = response.data;

      if (Array.isArray(data)) {
        // Sort data by date (newest first)
        const sortedData = data.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        setFiatWithdrawData(sortedData);
      } else {
        console.error("Unexpected response structure:", data);
        setFiatWithdrawData([]);
      }
    } catch (error) {
      console.error("Failed to fetch fiat withdrawal data:", error);
      setFiatWithdrawData([]);
    }
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const handleStatusChange = async (withdrawId: string, newStatus: string) => {
    try {
      if (activeTab === "crypto") {
        await axios.post(`${BASE}/updateWithdrawStatus`, {
          id: withdrawId,
          status: newStatus,
        });

        setWithdrawData((prevData) =>
          prevData.map((withdraw) =>
            withdraw.id === withdrawId ? { ...withdraw, status: newStatus } : withdraw
          )
        );
      } else {
        // Send the typed txn id along so marking a payout Done stores the reference too,
        // but never overwrite a reference that has already been recorded.
        const existing = fiatWithdrawData.find((w) => w.id === withdrawId);
        const typedTxnId = existing?.txn_id ? "" : (txnInputs[withdrawId] ?? "").trim();
        const { data } = await axios.post(`${BASE}/updateFiatWithdrawStatus`, {
          id: withdrawId,
          status: newStatus,
          ...(typedTxnId ? { txn_id: typedTxnId } : {}),
        });

        setFiatWithdrawData((prevData) =>
          prevData.map((withdraw) =>
            withdraw.id === withdrawId
              ? { ...withdraw, status: newStatus, txn_id: data?.txn_id ?? withdraw.txn_id }
              : withdraw
          )
        );
      }
    } catch (error) {
      console.error("Failed to update status:", error);
    }
  };

  const handleSaveTxnId = async (withdrawId: string) => {
    const txnId = (txnInputs[withdrawId] ?? "").trim();
    if (!txnId) {
      showToast("Please enter a transaction ID.", "warning");
      return;
    }

    setSavingTxnId(withdrawId);
    try {
      const { data } = await axios.post(`${BASE}/updateFiatWithdrawTxnId`, {
        id: withdrawId,
        txn_id: txnId,
      });

      setFiatWithdrawData((prevData) =>
        prevData.map((withdraw) =>
          withdraw.id === withdrawId
            ? { ...withdraw, txn_id: data?.txn_id ?? txnId }
            : withdraw
        )
      );
      setTxnInputs((prev) => {
        const next = { ...prev };
        delete next[withdrawId];
        return next;
      });
      showToast("Transaction ID saved");
    } catch (error) {
      console.error("Failed to save transaction ID:", error);
      const message = axios.isAxiosError(error)
        ? error.response?.data?.error
        : undefined;
      showToast(message || "Could not save the transaction ID. Please try again.", "error");
    } finally {
      setSavingTxnId(null);
    }
  };

  const filteredWithdrawData = withdrawData.filter((withdraw) => {
    if (searchTerm && !String(withdraw.uid).includes(searchTerm) && !withdraw.name.toLowerCase().includes(searchTerm.toLowerCase())) return false;
    if (statusFilter && withdraw.status !== statusFilter) return false;
    if (dateFrom && withdraw.date.slice(0,10) < dateFrom) return false;
    if (dateTo && withdraw.date.slice(0,10) > dateTo) return false;
    return true;
  });

  const filteredFiatWithdrawData = fiatWithdrawData.filter((withdraw) => {
    if (searchTerm && !String(withdraw.uid).includes(searchTerm) && !withdraw.name.toLowerCase().includes(searchTerm.toLowerCase()) && !withdraw.account_holder_name.toLowerCase().includes(searchTerm.toLowerCase())) return false;
    if (statusFilter && withdraw.status !== statusFilter) return false;
    if (dateFrom && withdraw.date.slice(0,10) < dateFrom) return false;
    if (dateTo && withdraw.date.slice(0,10) > dateTo) return false;
    return true;
  });

  // Download as CSV/Excel
  const downloadExcel = (data: any[], filename: string) => {
    if (!data || data.length === 0) { alert('No data to download'); return; }
    const headers = Object.keys(data[0]);
    const csvRows = [
      headers.join(','),
      ...data.map(row => headers.map(h => `"${String(row[h] ?? '').replace(/,/g, ' ')}"`).join(','))
    ];
    const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${filename}_${new Date().toISOString().slice(0,10)}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  const handleDownloadWithdrawals = () => {
    if (activeTab === 'crypto') {
      const exportData = filteredWithdrawData.map(w => ({
        UID: w.uid, Name: w.name, Amount: w.amount, Coin: w.coin,
        AmountUSDT: w.amount_usdt, Chain: w.chain, Wallet: w.wallet,
        Status: w.status, Date: new Date(w.date).toLocaleString()
      }));
      downloadExcel(exportData, 'crypto_withdrawals');
    } else {
      const exportData = filteredFiatWithdrawData.map(w => ({
        UID: w.uid, Name: w.name, Amount: w.amount, Currency: w.currency,
        AccountHolder: w.account_holder_name, Bank: w.bank_name || '',
        AccountNo: w.account_number || '', IFSC: w.ifsc_code || '',
        UPI: w.upi_id || '', TxnID: w.txn_id || '',
        Status: w.status, Date: new Date(w.date).toLocaleString()
      }));
      downloadExcel(exportData, 'fiat_withdrawals');
    }
  };

  const handleClearFilters = () => {
    setSearchTerm(''); setStatusFilter(''); setDateFrom(''); setDateTo('');
  };

  return (
    <div className="ml-0 lg:ml-[256px] min-h-screen bg-[#f3f4f6] p-6 text-gray-900">
      {/* Tab Selector */}
      <div className="mb-6 flex border-b border-gray-300">
        {isSuperAdmin && (
        <button
          className={`px-4 py-2 ${
            activeTab === "crypto"
              ? "border-b-2 border-[#25ee89] text-[#25ee89]"
              : "text-gray-500 hover:text-gray-900"
          }`}
          onClick={() => setActiveTab("crypto")}
        >
          Crypto Withdrawals
        </button>
        )}
        <button
          className={`px-4 py-2 ${
            activeTab === "fiat"
              ? "border-b-2 border-[#25ee89] text-[#25ee89]"
              : "text-gray-500 hover:text-gray-900"
          }`}
          onClick={() => setActiveTab("fiat")}
        >
          Fiat Withdrawals
        </button>
      </div>

      {/* Filters */}
      <div className="mb-6 bg-white p-4 rounded-lg shadow">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          <input
            type="text"
            placeholder={activeTab === "crypto" ? "Search by name or UID" : "Search by name, UID or account holder"}
            value={searchTerm}
            onChange={handleSearchChange}
            className="rounded-lg border border-gray-300 bg-white p-2 text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500"
          />
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="rounded-lg border border-gray-300 bg-white p-2 text-gray-900"
          >
            <option value="">All Status</option>
            <option value="In Queue">In Queue</option>
            <option value="Processing">Processing</option>
            <option value="Done">Done</option>
            <option value="Rejected">Rejected</option>
          </select>
          <input
            type="date"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
            className="rounded-lg border border-gray-300 bg-white p-2 text-gray-900"
            placeholder="From Date"
          />
          <input
            type="date"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
            className="rounded-lg border border-gray-300 bg-white p-2 text-gray-900"
            placeholder="To Date"
          />
          <div className="flex gap-2">
            <button
              onClick={handleClearFilters}
              className="px-3 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 text-sm"
            >
              Clear
            </button>
            <button
              onClick={handleDownloadWithdrawals}
              className="px-3 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 text-sm"
            >
               Download Excel
            </button>
          </div>
        </div>
        <div className="mt-2 text-sm text-gray-500">
          Showing {activeTab === 'crypto' ? filteredWithdrawData.length : filteredFiatWithdrawData.length} records
        </div>
      </div>

      {/* List of Withdrawals (Card-Based) */}
      {activeTab === "crypto" ? (
        <div className="space-y-4">
          {filteredWithdrawData.length > 0 ? (
            filteredWithdrawData.map((withdraw) => (
              <div
                key={withdraw.id}
                className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm transition duration-300 hover:shadow-md"
              >
                <div className="flex justify-between items-center">
                  <div>
                    <h2 className="text-lg font-semibold text-gray-900">
                      {withdraw.name} <span className="text-sm text-gray-500">(UID: {withdraw.uid})</span>
                    </h2>
                    <p className="text-sm text-gray-500">{new Date(withdraw.date).toLocaleDateString()}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-lg font-bold text-green-400">{withdraw.amount_usdt.toFixed(2)}</p>
                    <p className="text-sm text-gray-500">{withdraw.amount} {withdraw.coin}</p>
                  </div>
                </div>

                <div className="mt-4">
                  <p className="truncate text-sm text-gray-600">
                    <span className="font-semibold">Wallet:</span> {withdraw.wallet}
                  </p>
                </div>

                <div className="mt-4">
                  <p className="truncate text-sm text-gray-600">
                    <span className="font-semibold">Chain:</span> {withdraw.chain}
                  </p>
                </div>

                <div className="mt-4 flex justify-between items-center">
                  <span
                    className={`px-3 py-1 text-sm font-semibold rounded-full ${
                      withdraw.status === "In Queue"
                        ? "bg-yellow-500 text-black"
                        : withdraw.status === "Processing"
                        ? "bg-blue-500 text-white"
                        : withdraw.status === "Done"
                        ? "bg-green-500 text-white"
                        : "bg-red-500 text-white"
                    }`}
                  >
                    {withdraw.status}
                  </span>

                  <select
                    value={withdraw.status}
                    onChange={(e) => handleStatusChange(withdraw.id, e.target.value)}
                    disabled={withdraw.status === "Done" || withdraw.status === "Rejected"}
                    className={`cursor-pointer rounded-lg border border-gray-300 bg-white p-2 text-gray-900 ${
                      withdraw.status === "Done" || withdraw.status === "Rejected" ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  >
                    <option value="In Queue">In Queue</option>
                    <option value="Processing">Processing</option>
                    <option value="Done">Done</option>
                    <option value="Wager Not Completed">Wager Not Completed</option>
                    <option value="Rejected">Rejected</option>
                  </select>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500">No cryptocurrency withdrawal records found.</p>
          )}
        </div>
      ) : (
        <div className="space-y-4">
          {filteredFiatWithdrawData.length > 0 ? (
            filteredFiatWithdrawData.map((withdraw) => (
              <div
                key={withdraw.id}
                className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm transition duration-300 hover:shadow-md"
              >
                <div className="flex justify-between items-center">
                  <div>
                    <h2 className="text-lg font-semibold text-gray-900">
                      {withdraw.name} <span className="text-sm text-gray-500">(UID: {withdraw.uid})</span>
                    </h2>
                    <p className="text-sm text-gray-500">{new Date(withdraw.date).toLocaleDateString()}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-lg font-bold text-green-400">{withdraw.amount.toFixed(2)} {withdraw.currency}</p>
                  </div>
                </div>

                <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-2">
                  <p className="text-sm text-gray-600">
                    <span className="font-semibold">Account Holder:</span> {withdraw.account_holder_name}
                  </p>
                  
                  {withdraw.bank_name && (
                    <p className="text-sm text-gray-600">
                      <span className="font-semibold">Bank:</span> {withdraw.bank_name}
                    </p>
                  )}
                  
                  {withdraw.account_number && (
                    <p className="text-sm text-gray-600">
                      <span className="font-semibold">Account Number:</span> {withdraw.account_number}
                    </p>
                  )}
                  
                  {withdraw.ifsc_code && (
                    <p className="text-sm text-gray-600">
                      <span className="font-semibold">IFSC Code:</span> {withdraw.ifsc_code}
                    </p>
                  )}
                  
                  {withdraw.upi_id && (
                    <p className="text-sm text-gray-600">
                      <span className="font-semibold">UPI ID:</span> {withdraw.upi_id}
                    </p>
                  )}
                </div>

                {/* Payout transaction reference entered by the admin after sending the money.
                    Editable only while the payout is being actioned (Processing / Done). */}
                <div className="mt-4 border-t border-gray-200 pt-4">
                  {isTxnIdEditable(withdraw) ? (
                    <>
                      <label
                        htmlFor={`txn-${withdraw.id}`}
                        className="block text-sm font-semibold text-gray-700"
                      >
                        Transaction ID
                      </label>
                      <p className="mt-1 text-xs text-gray-500">
                        Reference of the payment sent to{" "}
                        {withdraw.upi_id || withdraw.account_number || "this account"}
                      </p>
                      <div className="mt-2 flex flex-col gap-2 sm:flex-row sm:items-center">
                        <input
                          id={`txn-${withdraw.id}`}
                          type="text"
                          maxLength={255}
                          value={txnInputs[withdraw.id] ?? withdraw.txn_id ?? ""}
                          onChange={(e) =>
                            setTxnInputs((prev) => ({ ...prev, [withdraw.id]: e.target.value }))
                          }
                          placeholder="e.g. UPI/UTR reference number"
                          className="w-full rounded-lg border border-gray-300 bg-white p-2 text-sm text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 sm:max-w-md"
                        />
                        <button
                          type="button"
                          onClick={() => handleSaveTxnId(withdraw.id)}
                          disabled={savingTxnId === withdraw.id}
                          className="rounded-lg bg-blue-500 px-3 py-2 text-sm text-white hover:bg-blue-600 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                          {savingTxnId === withdraw.id ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </>
                  ) : (
                    <p className="text-sm text-gray-600">
                      <span className="font-semibold">Transaction ID:</span>{" "}
                      {withdraw.txn_id ? (
                        <span className="font-medium text-gray-900">{withdraw.txn_id}</span>
                      ) : (
                        <span className="text-gray-400">
                          Not added yet — set status to Processing or Done to add it
                        </span>
                      )}
                    </p>
                  )}
                </div>

                <div className="mt-4 flex justify-between items-center">
                  <span
                    className={`px-3 py-1 text-sm font-semibold rounded-full ${
                      withdraw.status === "In Queue"
                        ? "bg-yellow-500 text-black"
                        : withdraw.status === "Processing"
                        ? "bg-blue-500 text-white"
                        : withdraw.status === "Done"
                        ? "bg-green-500 text-white"
                        : "bg-red-500 text-white"
                    }`}
                  >
                    {withdraw.status}
                  </span>

                  <select
                    value={withdraw.status}
                    onChange={(e) => handleStatusChange(withdraw.id, e.target.value)}
                    disabled={withdraw.status === "Done" || withdraw.status === "Rejected"}
                    className={`cursor-pointer rounded-lg border border-gray-300 bg-white p-2 text-gray-900 ${
                      withdraw.status === "Done" || withdraw.status === "Rejected" ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  >
                    <option value="In Queue">In Queue</option>
                    <option value="Processing">Processing</option>
                    <option value="Done">Done</option>
                    <option value="Rejected">Rejected</option>
                  </select>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500">No fiat withdrawal records found.</p>
          )}
        </div>
      )}

      <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={() => setToast((t) => ({ ...t, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={toast.severity}
          variant="filled"
          onClose={() => setToast((t) => ({ ...t, open: false }))}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default WithdrawSelf;
